/**
 * Location Edit - External Url module
 *
 * Implements text field module and keeps url and display url in sync
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.externalurl');

goog.require('yext.textfield');
goog.require('yext.location.helpers');

/**
 * External url view controller
 *
 * @param {!jQuery} $fields The context for the external url field
 *
 * @constructor
 */
yext.location.externalurl.ViewController = function($fields, isSuggestEditMode) {
  this.$fields = $fields;
  this.$preferredUrl = $fields.find('.js-preferred-url');
  this.$preferredRadios = $fields.find('.js-preferred-radios');
  this.$displayPreferredWrap = $fields.find('.js-display-preferred-wrap');
  this.$urlIndeterminate = $fields.find('.js-externalurl-url-indeterminate');
  this.$displayIndeterminate = $fields.find('.js-externalurl-display-indeterminate');

  this.isSuggestEditMode = isSuggestEditMode;

  // Original values stored
  this.storedValues = this.getValues();

  this.urlField = yext.textfield.create($fields.find('.js-externalurl-url .js-text-field'), 'externalUrl.url', undefined, this.isSuggestEditMode);
  this.displayField = yext.textfield.create($fields.find('.js-externalurl-display .js-text-field'), 'externalUrl.displayUrl', undefined, this.isSuggestEditMode);

  this.inSync = this.areSame();

  this.bindPreferred();
  this.presentation();
  this.sync();
};

/**
 * Get field values
 *
 * @return {!Object} External url field values
 */
yext.location.externalurl.ViewController.prototype.getValues = function() {
  return {
    urlIndeterminate: this.$urlIndeterminate.val(),
    displayIndeterminate: this.$displayIndeterminate.val(),
    preferDisplayUrl: this.$preferredRadios.find('input[type=radio]:checked').val(),
  };
};

/**
 * Presentation logic for external url
 */
yext.location.externalurl.ViewController.prototype.presentation = function() {
  this.toggleDisplayPreferred();
  this.togglePreference();
};

/**
 * Toggle preferred url panel
 */
yext.location.externalurl.ViewController.prototype.togglePreference = function() {
  if (this.inSync || !this.urlField.value()) {
    this.$preferredUrl.hide('fast');
  } else {
    this.$preferredUrl.show('fast');
  }
};

/**
 * Toggle the display url and preferred section
 */
yext.location.externalurl.ViewController.prototype.toggleDisplayPreferred = function() {
  var urlNotSet = !this.urlField.value();
  var urlDeterminate = this.$urlIndeterminate.val() == 'false';

  this.$displayPreferredWrap.toggle(!(urlNotSet && urlDeterminate) || this.fieldHasInheritedAsset());
};

/**
 * Sync the url with the display url
 */
yext.location.externalurl.ViewController.prototype.sync = function() {
  var self = this;
  $(this.urlField).on('update.textField', function() {
    self.$urlIndeterminate.val('false');

    if (self.inSync) {
      self.displayField.set(self.urlField.model);
    }

    self.toggleDisplayPreferred();
    self.addChangedInput('url');
    self.onUpdate();
  });

  $(this.displayField).on('update.textField', function() {
    self.$displayIndeterminate.val('false');
    self.addChangedInput('displayUrl');
    self.onUpdate();
  });
};

/**
 * Add a hidden changed flag
 *
 * @param {string} name Name of the changed field
 */
yext.location.externalurl.ViewController.prototype.addChangedInput = function(name) {
  this.$fields.append(yext.location.helpers.createChangedInput(name));
};

/**
 * Functions that should be triggered when url or display url are updated
 */
yext.location.externalurl.ViewController.prototype.onUpdate = function() {
  this.inSync = this.areSame();
  this.togglePreference();
  this.broadcast();
};

/**
 * Checks if the url and the display url are the same
 *
 * @return {boolean} True if they are equal
 */
yext.location.externalurl.ViewController.prototype.areSame = function() {
  return this.urlField.value() == this.displayField.value()
    && !this.fieldHasInheritedAsset();
};

yext.location.externalurl.ViewController.prototype.fieldHasInheritedAsset = function() {
  return this.urlField.isInheritedAsset || this.displayField.isInheritedAsset;
};

/**
 * Bind the preferred url radios
 */
yext.location.externalurl.ViewController.prototype.bindPreferred = function() {
  var self = this;
  this.$preferredRadios.find('input[type=radio]')
    .change(function() {
      self.broadcast();
    });
};

/**
 * Broadcast a message when the external url fields have been updated
 */
yext.location.externalurl.ViewController.prototype.broadcast = function() {
  $(this).trigger('update.externalUrl');
};

/**
 * Update fields to match the server
 */
yext.location.externalurl.ViewController.prototype.reconcile = function(field) {
  this.urlField.set(field.urlTextField);
  this.displayField.set(field.displayUrlTextField);
  this.$urlIndeterminate.val(field.urlTextField.indeterminate);
  this.$displayIndeterminate.val(field.displayUrlTextField.indeterminate);

  if (field.preferDisplayUrlIndeterminate) {
    this.setPreferredRadios();
  } else {
    this.setPreferredRadios(field.preferDisplayUrl);
  }

  // Store new values
  this.urlField.saveValue();
  this.displayField.saveValue();
  this.storedValues = this.getValues();

  yext.location.helpers.removeChangedInputs(this.$fields);
};

/**
 * Reset the field to its original state
 */
yext.location.externalurl.ViewController.prototype.reset = function() {
  this.urlField.reset();
  this.displayField.reset();
  this.$urlIndeterminate.val(this.storedValues.urlIndeterminate);
  this.$displayIndeterminate.val(this.storedValues.displayIndeterminate);
  this.setPreferredRadios(this.storedValues.preferDisplayUrl);
  this.presentation();
  yext.location.helpers.removeChangedInputs(this.$fields);
};

/**
 * Set the preferred radios field
 *
 * @param {boolean|string} value The value to set the radio fields to
 */
yext.location.externalurl.ViewController.prototype.setPreferredRadios = function(value) {
  if (typeof value == 'undefined') {
    this.$preferredRadios.find('input[type=radio]')
      .prop('checked', false);
  } else {
    this.$preferredRadios
      .find('input[type=radio][value=' + String(value) + ']')
      .prop('checked', true);
  }
};

/**
 * Check to see if the external url is in a determinate state
 *
 * @return {boolean} True if determinate
 */
yext.location.externalurl.ViewController.prototype.determinate = function() {
  return this.storedValues.urlIndeterminate !== 'true'
    && this.storedValues.displayIndeterminate !== 'true'
    && this.storedValues.preferDisplayUrl != undefined;
};

/**
 * Generate view markup
 *
 * @return {!Array.<jQuery>} Array of view markup elements
 */
yext.location.externalurl.ViewController.prototype.viewMarkup = function() {
  if (this.determinate()) {
    var markup = [];

    if (this.urlField.displayValue()) {
      markup.push($('<div>').attr('class', 'website-visible-url').html(this.displayField.viewMarkup()));
      markup.push($('<div>').attr('class', 'website-target-url').html(this.urlField.viewMarkup()));
    } else {
      // This will be click to add message
      markup.push(this.urlField.viewMarkup());
    }

    return markup;
  } else {
    return yext.location.helpers.variousContentMessage();
  }
};
